<template>
<div class="chapter">
<div class="inner_page">
<div class="boxnote1">
<h2 class="h2"><a id="page_5"></a><a id="part1"></a><span class="underline">P<span class="smallcaps">ART</span> I</span><br/>S<span class="smallcaps">ECOND</span> E<span class="smallcaps">DITION</span></h2>
<h2 class="h2a"><em>Selling<br/>With<br/>Intention</em><a id="page_6"></a></h2>
<p class="linespace"> </p>
<p class="linespace"> </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?da830e84